import { useState } from 'react'
import './Gallery.css'

interface GalleryImage {
  id: number
  src: string
  alt: string
  category: 'wedding' | 'party' | 'karaoke' | 'equipment'
  description: string
}

const galleryImages: GalleryImage[] = [
  {
    id: 1,
    src: '/images/gallery/wedding-1.jpg',
    alt: 'Wedding Sound Setup',
    category: 'wedding',
    description: 'Professional sound setup for an outdoor wedding ceremony'
  },
  {
    id: 2,
    src: '/images/gallery/party-1.jpg',
    alt: 'Party Event',
    category: 'party',
    description: 'Full sound system setup for a corporate party'
  },
  {
    id: 3,
    src: '/images/gallery/karaoke-1.jpg',
    alt: 'Karaoke Night',
    category: 'karaoke',
    description: 'Karaoke setup with dual screens and wireless microphones'
  },
  {
    id: 4,
    src: '/images/gallery/equipment-1.jpg',
    alt: 'Professional Speakers',
    category: 'equipment',
    description: 'High-end professional speaker system'
  },
  {
    id: 5,
    src: '/images/gallery/wedding-2.jpg',
    alt: 'Wedding Reception',
    category: 'wedding',
    description: 'Dance floor and lighting setup for wedding reception'
  },
  {
    id: 6,
    src: '/images/gallery/equipment-2.jpg',
    alt: 'DJ Equipment',
    category: 'equipment',
    description: 'Professional DJ controller and mixing equipment'
  }
]

export function Gallery() {
  const [selectedImage, setSelectedImage] = useState<GalleryImage | null>(null)
  const [activeCategory, setActiveCategory] = useState<string>('all')

  const categories = [
    { id: 'all', label: 'All' },
    { id: 'wedding', label: 'Weddings' },
    { id: 'party', label: 'Parties' },
    { id: 'karaoke', label: 'Karaoke' },
    { id: 'equipment', label: 'Equipment' }
  ]

  const filteredImages = activeCategory === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.category === activeCategory)

  return (
    <section className="gallery">
      <h2>Our Gallery</h2>
      <p className="gallery-intro">
        Take a look at our past events and professional equipment
      </p>

      <div className="gallery-filters">
        {categories.map(category => (
          <button
            key={category.id}
            className={`filter-button ${activeCategory === category.id ? 'active' : ''}`}
            onClick={() => setActiveCategory(category.id)}
          >
            {category.label}
          </button>
        ))}
      </div>

      <div className="gallery-grid">
        {filteredImages.map(image => (
          <div
            key={image.id}
            className="gallery-item"
            onClick={() => setSelectedImage(image)}
          >
            <img src={image.src} alt={image.alt} loading="lazy" />
            <div className="gallery-item-overlay">
              <h3>{image.alt}</h3>
              <p>{image.description}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={() => setSelectedImage(null)}>
          <button 
            className="lightbox-close" 
            onClick={() => setSelectedImage(null)}
            aria-label="Close image preview"
          >
            ×
          </button>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.alt} />
            <div className="lightbox-info">
              <h3>{selectedImage.alt}</h3>
              <p>{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  )
} 